import { Fragment } from 'react';

import { InboxSectionHeader } from './components/InboxSectionHeader';
import { useInboxSectionAccordion } from './hooks/useInboxSectionAccordion';
import { InboxType } from '../../types';
import { InboxNavLink } from '../InboxNavLink';
import { ScheduledInboxNavLink } from '../ScheduledInboxNavLink';
import { SnoozedInboxNavLink } from '../SnoozedInboxNavLink';

const INBOX_SECTION_MAIN_TYPE: InboxType = 'main';

const stylesheet = {
  container: 'flex flex-col gap-1',
  linksContainer: 'flex flex-col',
  linksContainerOpen: 'mt-1 space-y-1',
  linksContainerClosed: 'mt-1 gap-1 rounded-semantic bg-semantic-bg-subtle',
};

type InboxSectionProps = Readonly<{
  isOpen: boolean;
  onNavigate?: () => void;
  items: Array<{ type: InboxType; showCounter?: boolean }>;
}>;

export function InboxSection({
  isOpen: isSidebarOpen,
  onNavigate,
  items,
}: InboxSectionProps) {
  const { isAccordionOpen, onToggleAccordion } = useInboxSectionAccordion();

  const linksContainerClass = `${stylesheet.linksContainer} ${isSidebarOpen ? stylesheet.linksContainerOpen : stylesheet.linksContainerClosed}`;

  return (
    <div className={stylesheet.container}>
      <InboxSectionHeader
        isSidebarOpen={isSidebarOpen}
        isAccordionOpen={isAccordionOpen}
        onToggleAccordion={onToggleAccordion}
      />

      {isAccordionOpen && (
        <div className={linksContainerClass}>
          {items.map(({ type, showCounter }) => (
            <Fragment key={type}>
              <InboxNavLink
                type={type}
                isOpen={isSidebarOpen}
                onNavigate={onNavigate}
                showCounter={showCounter}
              />
              {type === INBOX_SECTION_MAIN_TYPE && (
                <SnoozedInboxNavLink
                  isOpen={isSidebarOpen}
                  onNavigate={onNavigate}
                />
              )}
            </Fragment>
          ))}
          <ScheduledInboxNavLink
            isOpen={isSidebarOpen}
            onNavigate={onNavigate}
          />
        </div>
      )}
    </div>
  );
}
